/**
 * @module hotspotHelpers
 */
import * as THREE from 'three';

export const getHotspotTargetObject = (parent_hotspot_id, scene) => {
	if (!parent_hotspot_id || parent_hotspot_id === 'scene') return scene;
	else if (parent_hotspot_id === 'scene_model')
		return scene.getObjectByName('scene_model');
	else if (parent_hotspot_id)
		return scene?.children?.find(
			(item) => item?.userData?._id === parent_hotspot_id,
		);
	else return scene;
};

export const addSphereAtPosition = (
	scene,
	position,
	radius = 0.1,
	color = 'red',
) => {
	const geometry = new THREE.SphereGeometry(radius, 32, 32);
	const material = new THREE.MeshBasicMaterial({ color: color });
	const sphere = new THREE.Mesh(geometry, material);
	sphere.position.set(position.x, position.y, position.z);
	scene.add(sphere);
};

// const createHotspotMarker = ({
// 	imageURL,
// 	imageHoverURL,
// 	soundURL,
// 	iconConfig,
// 	userData = {},
// 	UIConfig,
// 	tooltipConfig,
// 	onClick,
// 	animation,
// 	transform,
// 	camera,
// 	canvas,
// 	enableDepthTest,
// }) => {
// 	return new HotspotMarker({
// 		iconConfig,
// 		imageURL,
// 		imageHoverURL,
// 		soundURL,
// 		userData,
// 		UIConfig,
// 		tooltipConfig,
// 		onClick,
// 		animation,
// 		transform,
// 		camera,
// 		canvas,
// 		enableDepthTest,
// 	});
// };

// export const createAndRenderHotspotMarkerOnEvent = (
// 	e,
// 	data,
// 	point,
// 	objectPlacementTarget,
// ) => {
// 	console.log('>>createAndRenderHotspotMarkerOnEvent', {
// 		e,
// 		data,
// 		point,
// 		objectPlacementTarget,
// 	});
// 	//#1. Create
// 	const newMarker = createHotspotMarker({
// 		userData: data.userData,
// 		UIConfig: data.UIConfig,
// 		animation: data.animation,
// 	});
//
// 	//#2. Add to the scene
// 	newMarker.addToScene(objectPlacementTarget);
//
// 	//#3. Config
// 	newMarker.setScale();
// 	newMarker.setPosition(point.x, point.y, point.z);
//
// 	//#4. open UI
// 	newMarker.onClick(e);
// 	return newMarker;
// };

// /**
//  * Renders marker from stored hotspot record {}
//  * @param props - scene object
//  * @param sceneRef
//  * @param camera
//  * @returns {HotspotMarker}
//  */
// export const renderHotspotRecord = (
// 	props = {},
// 	camera,
// 	canvas,
// 	objectPlacementTarget,
// 	enableDepthTest,
// ) => {
// 	return new HotspotMarker({
// 		...props,
// 		camera,
// 		canvas,
// 		enableDepthTest,
// 		onReady: (_marker) => {
// 			_marker.addToScene(objectPlacementTarget);
// 			_marker.setTransform(props.collider_transform, props.transform);
// 		},
// 	});
// };
